export default __webpack_public_path__ + "static/media/pangolin.45f098ec.png";